import React from "react";

const TermsOfService = () => {
  return (
    <div className="pt-24 pb-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">
          Terms of Service
        </h1>

        <div className="prose prose-lg max-w-none">
          <p className="text-gray-700 mb-6">Welcome to CIVILSCODE</p>

          <p className="text-gray-700 mb-6">
            Thank you for choosing CIVILSCODE for your UPSC civil services
            examination preparation. By accessing our website and using our
            services, you agree to be bound by the following terms and
            conditions (Terms). Please read them carefully.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
            <b>Use of Our Services</b>
          </h2>

          <p className="text-gray-700 mb-6">
            CIVILSCODE provides a variety of educational resources, including
            but not limited to, NCERT Simplified notes, 360-Degree Notes, and
            personalized learning tools. These services are intended for
            personal, non-commercial use only.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
            <b>Account Registration</b>
          </h2>

          <p className="text-gray-700 mb-6">
            You may be required to create an account to access certain features.
            You agree to provide accurate, current, and complete information
            during the registration process and to update such information to
            keep it accurate, current, and complete.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
            <b>Content Use</b>
          </h2>

          <p className="text-gray-700 mb-6">
            The content provided on CIVILSCODE, including text, graphics, logos,
            and software, is the property of CIVILSCODE or its content suppliers
            and protected by Indian and international copyright laws.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
            <b>User Conduct</b>
          </h2>

          <ul className="list-disc pl-6 mb-6 text-gray-700">
            <li className="mb-2">
              You agree not to use the website or its content for any unlawful
              purpose.
            </li>
            <li className="mb-2">
              You agree not to infringe on the intellectual property rights of
              CIVILSCODE or others.
            </li>
            <li className="mb-2">
              You agree not to upload, post, email, or otherwise transmit any
              content that is unlawful, harmful, threatening, abusive,
              harassing, tortious, defamatory, vulgar, obscene, libelous,
              invasive of another's privacy, hateful, or racially, ethnically,
              or otherwise objectionable.
            </li>
            <li className="mb-2">
              You agree not to share credentials with other users, also agree to
              have only one session at any time.
            </li>
            <li className="mb-2">
              Breach in user conduct may not only lead to termination of
              subscription but also lead to law suits.
            </li>
          </ul>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
            <b>Subscription Fees and Payments</b>
          </h2>

          <p className="text-gray-700 mb-6">
            Some parts of the Service are billed on a subscription basis. You
            will be billed in advance on a recurring and periodic basis (Billing
            Cycle). All successful payments to CIVILSCODE are not refundable.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
            <b>Changes to Terms and Conditions</b>
          </h2>

          <p className="text-gray-700 mb-6">
            CIVILSCODE reserves the right, at its sole discretion, to modify or
            replace these Terms at any time. We will provide notice of any
            changes by posting the new Terms on the website. Your continued use
            of the Service after such changes constitutes acceptance of the new
            Terms.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
            <b>Disclaimer of Warranties and Limitation of Liability</b>
          </h2>

          <p className="text-gray-700 mb-6">
            The services and content of CIVILSCODE are provided on an 'as is'
            and 'as available' basis without any warranties of any kind, either
            express or implied. CIVILSCODE does not warrant that the service
            will be uninterrupted, timely, secure, or error-free.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
            <b>Governing Laws</b>
          </h2>

          <p className="text-gray-700 mb-6">
            These Terms shall be governed by and construed in accordance with
            the laws of India, providing a clear legal framework for both
            CIVILSCODE and its users. In navigating the complexities of digital
            education and online services, we adhere to the following key
            statutes and regulations, ensuring our operations are not only
            innovative but also legally compliant:
          </p>

          <p className="text-gray-700 mb-6">
            Information Technology Act, 2000 (IT Act): As the primary law in
            India dealing with cybercrime and electronic commerce, the IT Act
            outlines the legal obligations concerning digital communications and
            transactions. This includes provisions for the protection of
            personal data collected and processed by online platforms like
            CIVILSCODE.
          </p>

          <p className="text-gray-700 mb-6">
            Information Technology (Reasonable Security Practices and Procedures
            and Sensitive Personal Data or Information) Rules, 2011: These rules
            further define the standards for protecting sensitive personal data,
            emphasizing the importance of consent, security practices, and the
            user's rights in relation to their personal information.
          </p>

          <p className="text-gray-700 mb-6">
            Information Technology (Intermediary Guidelines and Digital Media
            Ethics Code) Rules, 2021: These guidelines establish the
            responsibilities of intermediaries, including edtech platforms, in
            moderating and managing user-generated content, ensuring a safe and
            respectful online environment.
          </p>

          <p className="text-gray-700 mb-6">
            Consumer Protection Act, 2019: This act provides for the protection
            of consumer rights, including those of students and learners using
            educational services and products. It addresses unfair trade
            practices, misleading advertisements, and provides for consumer
            redressal mechanisms.
          </p>

          <p className="text-gray-700 mb-6">
            Copyright Act, 1957: Protecting the intellectual property rights of
            the content creators and the educational materials provided on
            CIVILSCODE, this law ensures that original works are safeguarded
            against unauthorized use and distribution.
          </p>

          <p className="text-gray-700 mb-6">
            By agreeing to these Terms, users affirm their understanding and
            compliance with the legal provisions under these statutes. Any
            disputes arising in connection with the use of CIVILSCODE's services
            will be resolved through arbitration or in the competent courts
            within India, adhering to the principles and procedures outlined in
            the aforementioned laws.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
            <b>Refund & Cancellation Policy:</b>
          </h2>

          <ol className="list-decimal pl-6 mb-6 text-gray-700">
            <li className="mb-4">
              <span className="font-semibold">Transaction Responsibility:</span>
              <br />
              All monetary transactions made by the user through the site are
              processed via the payment gateway partner of CivilSphere.
              CivilSphere is not responsible for any discrepancies arising from
              the payment process. It is the user's responsibility to ensure
              that payment details are entered accurately.
            </li>
            <li className="mb-4">
              <span className="font-semibold">Refund Eligibility:</span>
              <br />
              CivilSphere reserves the right to consider and review refund
              requests only if the amount paid by the user exceeds the fee for
              the number of applications submitted. Refunds will not be granted
              for payments made in excess due to user error unless there is
              clear evidence of overpayment directly attributable to a system
              malfunction.
            </li>
            <li className="mb-4">
              <span className="font-semibold">Payment Verification:</span>
              <br />
              Users are required to keep a record of the Transaction ID and
              receipt number provided by the payment gateway. These details may
              be needed to furnish additional information or track the payment
              status of an application. Failure to provide these details may
              delay or prevent the resolution of payment issues.
            </li>
            <li className="mb-4">
              <span className="font-semibold">Non-Refundable Payments:</span>
              <br />
              Payments for services are generally non-refundable. Exceptions may
              be made at the discretion of CivilSphere, based on specific
              circumstances, but are not guaranteed.
            </li>
            <li className="mb-4">
              <span className="font-semibold">Service Disruption:</span>
              <br />
              In the unlikely event of a technical error or service disruption
              during the payment process that results in an incorrect
              transaction, CivilSphere will work with the payment gateway to
              investigate and resolve the issue. Refunds or payment adjustments
              may be considered if it is determined that the error was on the
              part of the system.
            </li>
            <li className="mb-4">
              <span className="font-semibold">Cancellation Policy:</span>
              <br />
              Once a registration has been done and payment has been made,
              cancellations will not be entertained. The registration will be
              considered final and binding. Users should review their
              application details thoroughly before completing the payment
              process.
            </li>
            <li className="mb-4">
              <span className="font-semibold">Legal Liability:</span>
              <br />
              CivilSphere is not liable for any legal claims arising from the
              use of third-party payment gateways. All users are advised to read
              and understand the payment terms and conditions before initiating
              any transactions.
            </li>
          </ol>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
            <b>Contact Us</b>
          </h2>

          <p className="text-gray-700 mb-6">
            If you have any questions about these Terms, please contact us at
            +917995467223
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
